import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger.js'
import { runSkew } from '../skew-on-scroll'
import { breakpointDown, breakpointUp } from '../utils/breakpoints'
import { isTouchDevice} from '../utils/checkDevice'

let body = $('body')


gsap.registerPlugin(ScrollTrigger)

function updateUrl(url)
{
  url = url ? url : '/'

  window.history.pushState('', '', url);
}


function initHeaderMenuSequence()
{
  if(breakpointDown('lg')) return

  let navHeader = $('.nav-header')
  let topOffset = navHeader.height()

  setTimeout(function () {
  gsap.utils.toArray('.section-trigger').forEach(element => {
    function triggerEnter() {
      // Check if this is the first section
      if ($(element).is('.smooth-scroll section:first-child')) {
        navHeader.removeClass('dark-menu light-menu').addClass('dark-menu'); // Change to black color
      } else {
        navHeader.removeClass('dark-menu light-menu').addClass($(element).data('theme-down'));
      }

      runSkew($(element).data('trigger-skew-down'));
      updateUrl($(element).data('url'));
    }

    function triggerEnterBack() {
      updateUrl($(element).data('url-leave'));
    }

    function triggerLeaveBack() {
      // Check if this is the first section
      if ($(element).is('.smooth-scroll section:first-child')) {
        navHeader.removeClass('dark-menu light-menu').addClass('dark-menu'); // Change to black color
      } else {
        navHeader.removeClass('dark-menu light-menu').addClass($(element).data('theme-up'));
      }

      runSkew($(element).data('trigger-skew-up'));
      $('.sound-switch-container').attr('style', '');
    }

    ScrollTrigger.create({
      trigger: element,
      start: 'top ' + topOffset,
      end: 'bottom bottom',
      scrub: true,
      onEnter: triggerEnter,
      onLeaveBack: triggerLeaveBack,
      onEnterBack: triggerEnterBack,
    });
  });

  gsap.utils.toArray('.section-scroll-trigger').forEach(element => {
    function triggerHeaderBottomDown() {
      navHeader.removeClass('dark-scroll light-scroll').addClass($(element).data('scroll-down'));

      if ($(element).data('hide-scroll') === 1) {
        $('.nav-header .live-scroll').addClass('hidden');
      }

      updateUrl($(element).data('url'));
    }

    function triggerHeaderBottomUp() {
      navHeader.removeClass('dark-scroll light-scroll').addClass($(element).data('scroll-up'));
      $('.nav-header .live-scroll').removeClass('hidden');
      updateUrl($(element).data('url-leave'));
    }

    function triggerEnterBack() {
      updateUrl($(element).data('url-leave'));
    }

    ScrollTrigger.create({
      trigger: element,
      start: 'top bottom-=5%',
      end: 'bottom bottom',
      scrub: true,
      onEnter: triggerHeaderBottomDown,
      onLeaveBack: triggerHeaderBottomUp,
      onEnterBack: triggerEnterBack,
    });
  });
}, 500);



}

/**
 * Toggle menu popup
 */
body.on('click', '.js-header-menu_btn, .main-menu a', function (e) {

    $('.hamburger').toggleClass('is-active')
    $('.nav-header').toggleClass('opened')
    $('body').toggleClass('js-opened-nav-header-menu')
    $('.scroll-trigger').toggleClass('not-visible')
})

body.on('click', '.main-menu', function (e){
  if($(e.target).is('a, button')) return
  $('.hamburger').removeClass('is-active')
  $('.nav-header').removeClass('opened')
  $('body').toggleClass('js-opened-nav-header-menu')
  $('.scroll-trigger').removeClass('not-visible')

})

if(breakpointUp('md')) {



  let footerHeightWithPadding = $('footer').height() + 42
  let fromBottom = $(window).height() + footerHeightWithPadding
  let soundSwitch = $('.sound-switch-container')
  let distanceFromBottom = 0
  $(window).on('scroll', function (e){

    distanceFromBottom = $(document).height() - $(window).scrollTop()

    if(fromBottom > distanceFromBottom) {
      soundSwitch.css('bottom', fromBottom - distanceFromBottom)
    } else {
      soundSwitch.attr('style', '')
    }

  })

}

if(!isTouchDevice()) {
  /**
   * Add active class to hovered menu item and in-active classes to siblings
   */

  body.on('mouseenter', '.main-menu .menu-link', function (e){
    $(this).closest('.menu').addClass('has-hover')
  })

  body.on('mouseleave', '.main-menu .menu-link', function (e){
    $(this).closest('.menu').removeClass('has-hover')
  })
}

export { initHeaderMenuSequence }
